/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stato di un TipoPratica nel ciclo di vita del bando
 */
export enum TipoPraticaStato {

    IN_ATTESA = 'IN_ATTESA',

    RICEZIONE_RICHIESTE = 'RICEZIONE_RICHIESTE',

    VALUTAZIONE_RICHIESTE = 'VALUTAZIONE_RICHIESTE',

    GRADUATORIA_CONFERMATA = 'GRADUATORIA_CONFERMATA',

    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',

    VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI',

    NUOVA_RICEZIONE_RICHIESTE = 'NUOVA_RICEZIONE_RICHIESTE',

    RIVALUTAZIONE_RICHIESTE = 'RIVALUTAZIONE_RICHIESTE',

    ARCHIVIATA = 'ARCHIVIATA'
}

